<template>
  <div class="simpleness">
    <top-banner
      class="simpleness-topBanner"
      :hasOpenThatBank="hasOpenThatBank"
      :currentBankHasBinding="currentBankHasBinding"
      :couponImgForTOConfig="couponImgForTOConfig"
    />
    <introduction
      :hasOpenThatBank="hasOpenThatBank"
      :bankName="bankName"
      :bankType="bankType"
      :currentBankHasBinding="currentBankHasBinding"
      :couponPackage="couponPackage"
      :applyPageType="applyPageType"
      :pageABStrategy="pageABStrategy"
      :pushSubWalletABStrategy="pushSubWalletABStrategy"
    />
    <bottom-button
      v-if="!currentBankHasBinding"
      :mobileMask="mobileMask"
      :bankName="bankName"
      :bankType="bankType"
      :hasOpenThatBank="hasOpenThatBank"
      :couponPackage="couponPackage"
      :applyPageType="applyPageType"
      :pageABStrategy="pageABStrategy"
      :pushSubWalletABStrategy="pushSubWalletABStrategy"
    />
  </div>
</template>
<script>
import TopBanner from './components/TopBanner.vue';
import Introduction from './components/Introduction.vue';
import BottomButton from './components/BottomButton.vue';
export default {
  components: {
    TopBanner,
    Introduction,
    BottomButton
  },
  props: {
    currentBankHasBinding: {
      type: Boolean,
      default: false
    },
    hasOpenThatBank: {
      type: Boolean,
      default: false
    },
    mobileMask: {
      type: String,
      default: ""
    },
    couponPackage: {
      type: Object,
      default: () => {}
    },
    bankType: {
      type: String,
      default: ''
    },
    bankName: {
      type: String,
      default: ''
    },
    applyPageType: {
      type: String,
      default: ''
    },
    pageABStrategy: {
      type: String,
      default: ''
    },
    pushSubWalletABStrategy: {
      type: String,
      default: ''
    },
    couponImgForTOConfig: {
      type: Object,
      default:() => {}
    }
  }
};
</script>
<style scoped lang="less">
.simpleness {
  padding-bottom: 3.8rem;
  &-topBanner {
    margin-bottom: 0.27rem;
  }
}
</style>
